export default "__VITE_ASSET__4754a298__"